export const EMAIL_COLOR = {
  accent: '#4550E6',
  primary: '#1F1F1F',
  primaryInverted: '#FFFFFF',
  secondary: '#9DA8AB',
  background: '#EDEEF0',
} as const;

export const EMAIL_COLORS = [
  EMAIL_COLOR.accent,
  EMAIL_COLOR.primary,
  EMAIL_COLOR.secondary,
  EMAIL_COLOR.background,
  EMAIL_COLOR.primaryInverted,
];
